export const WaitTime = 2000;
